import React from 'react';

import { Newsletter } from '@hooks/useCurrentNewsletter';

import NewsletterSignUp from '../NewsletterSignup';
import styles from './footerStyles.module.scss';

interface FooterProps {
  currentUserAccessLevel: number;
  isLoggedIn: boolean;
  isSubscribed: boolean;
  gdprColorScheme: string;
  gdpr: boolean;
  newsletter: Newsletter;
}

const Footer = ({
  currentUserAccessLevel,
  isLoggedIn,
  isSubscribed,
  gdprColorScheme,
  gdpr,
  newsletter,
}: FooterProps) => {
  return (
    <div className={styles.feedNewsletterContainer} id="feed-newsletter-container-footer">
      <div className={styles.feedNewsletterWrapper}>
        <div className={styles.newsletterImageCard}>
          <img src={newsletter.cardImageUrlImgix} />
        </div>
        <div className={styles.newsletterFormWrapper}>
          <div className={styles.frequency}>{newsletter.frequency}</div>
          <div className={styles.byline}>
            {newsletter.name} by {newsletter.author.name}
          </div>
          <div className={styles.description}>{newsletter.description}</div>
          <NewsletterSignUp
            currentUserAccessLevel={currentUserAccessLevel}
            isLoggedIn={isLoggedIn}
            isSubscribed={isSubscribed}
            gdpr={gdpr}
            gdprColorScheme={gdprColorScheme}
            newsletter={newsletter}
          />
        </div>
      </div>
    </div>
  );
};

export default Footer;
